"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaAccountBalanceResponseToJSON = exports.RosettaAccountBalanceResponseFromJSONTyped = exports.RosettaAccountBalanceResponseFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function RosettaAccountBalanceResponseFromJSON(json) {
    return RosettaAccountBalanceResponseFromJSONTyped(json, false);
}
exports.RosettaAccountBalanceResponseFromJSON = RosettaAccountBalanceResponseFromJSON;
function RosettaAccountBalanceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'block_identifier': json['block_identifier'],
        'balances': (json['balances'].map(_1.RosettaAmountFromJSON)),
        'coins': !runtime_1.exists(json, 'coins') ? undefined : (json['coins'].map(_1.RosettaCoinFromJSON)),
        'metadata': !runtime_1.exists(json, 'metadata') ? undefined : _1.RosettaAccountBalanceResponseMetadataFromJSON(json['metadata']),
    };
}
exports.RosettaAccountBalanceResponseFromJSONTyped = RosettaAccountBalanceResponseFromJSONTyped;
function RosettaAccountBalanceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'block_identifier': value.block_identifier,
        'balances': (value.balances.map(_1.RosettaAmountToJSON)),
        'coins': value.coins === undefined ? undefined : (value.coins.map(_1.RosettaCoinToJSON)),
        'metadata': _1.RosettaAccountBalanceResponseMetadataToJSON(value.metadata),
    };
}
exports.RosettaAccountBalanceResponseToJSON = RosettaAccountBalanceResponseToJSON;
//# sourceMappingURL=RosettaAccountBalanceResponse.js.map